import { cssVar } from 'theme';

const styles = theme => ({
  root: {
    background: theme.palette.common.white,
    border: theme.customBorders.gray200,
    color: theme.palette.common.gray800,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1, 2),
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  // Each stripe carries the same value as the icon beside it, so a variant
  // cannot render a mint rule against a forest checkmark.
  success: {
    boxShadow: `0px 8px 16px rgba(15, 23, 42, 0.16), inset 2px 0px 0px ${cssVar(
      'success',
      '#3e8334',
    )}`,
  },
  error: {
    boxShadow: `0px 8px 16px rgba(15, 23, 42, 0.16), inset 2px 0px 0px ${cssVar(
      'danger',
      '#e11d48',
    )}`,
  },
  info: {
    boxShadow: `0px 8px 16px rgba(15, 23, 42, 0.16), inset 2px 0px 0px ${theme.palette.common.infoMark}`,
  },
  warning: {
    boxShadow: `0px 8px 16px rgba(15, 23, 42, 0.16), inset 2px 0px 0px ${cssVar(
      'warning',
      '#f68006',
    )}`,
  },
  action: {
    margin: 0,
    padding: 0,
  },
  message: {
    padding: theme.spacing(0, 1),
  },
  // MUI's `ButtonBase` sets `outline: 0`, and the theme turns the focus ripple
  // off, so without this the Close button shows nothing when it takes focus.
  button: {
    padding: 0,
    height: theme.spacing(2),
    width: theme.spacing(2),
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  close: {
    color: theme.palette.common.gray500,
    height: theme.spacing(2),
    width: theme.spacing(2),
  },
  icon: {
    marginRight: theme.spacing(),
  },
});

export default styles;
